import config from '@/config'
import { requestsV2 } from '.'

export interface IProposalCustomerCustomNotificationSettings {
  locationId: string
  documentReceivedTemplateId?: string | null
  documentSignedTemplateId?: string | null
  documentSignedTemplateIdForTeam?: string | null
  enableDocumentReceiveNotification: boolean
  enableDocumentSignedNotification: boolean
  enableDocumentSignedForTeamNotification: boolean
  enableAutoSentInvoice?: boolean
  documentReceivedSubject?: string
  documentSignedSubject?: string
  overrideSignedForTeamEmailSender: boolean
  documentSignedForTeamEmail?: string
  documentSignedForTeamEmailFromName?: string
  documentSignedForTeamSubject?: string
  _id?: string
  overrideSignedEmailSender: boolean
  documentSignedEmail?: string
  documentSignedEmailFromName?: string
  overrideReceivedEmailSender: boolean
  documentReceivedEmail?: string
  documentReceivedEmailFromName?: string
  enableDirectPayment: boolean
}

export const CustomNotificationService = {
  getCustomNotificationSetting: (params: { locationId: string }) =>
    requestsV2(
      config.PROPOSAL_SERVICE_URL
    ).get<IProposalCustomerCustomNotificationSettings>(
      `/settings/${params?.locationId}`
    ),

  //TODO: not needed
  updateCustomNotificationSetting: (
    params: IProposalCustomerCustomNotificationSettings
  ) =>
    requestsV2(
      config.PROPOSAL_SERVICE_URL
    ).put<IProposalCustomerCustomNotificationSettings>(
      '/settings/update',
      params
    ),
}
